import { Button } from 'primereact/button';
import { MouseEvent, useLayoutEffect } from 'react';

import { PositionedTree } from '../../../pages/mindmap/types';
import { useMindmap } from '../../../pages/mindmap/use-mindmap';
import { usePrevious } from './../../../hooks/use-previous';

type ToolPanelButtonProps = {
  onClick: (e: MouseEvent) => void;
  node: PositionedTree;
};

export const ToolPanelButton = ({ onClick, node }: ToolPanelButtonProps) => {
  const {
    interactableMap: { positionContextMenu, contextMenuOpen, moveContextMenuMapCoords },
    contextMenu: { activeMenu, hideContextMenu, setActiveMenu },
  } = useMindmap();

  const open = (e: MouseEvent) => {
    positionContextMenu(e, false);
    if (activeMenu?.type == 'edit-node') hideContextMenu();
    else setActiveMenu({ type: 'edit-node' });
    onClick(e);
  };

  const prevNodeX = usePrevious(node.x);
  const prevNodeY = usePrevious(node.y);

  // update contextMenuMapCoords when node position changes
  useLayoutEffect(() => {
    if (contextMenuOpen && prevNodeX != undefined && prevNodeY != undefined) {
      const nodeXDiff = node.x - prevNodeX;
      const nodeYDiff = node.y - prevNodeY;
      moveContextMenuMapCoords(nodeXDiff, nodeYDiff);
    }
  }, [node.x, node.y]);

  return (
    <>
      <Button
        type="button"
        id="modify-button"
        icon="pi pi-ellipsis-h"
        onClick={open}
        className="p-button-rounded p-button-secondary"
      />
    </>
  );
};
